// FOREIGN single-product page — interactions + restrained cinematic motion.
(function () {
  'use strict';

  /* ── Shopify bridge ──────────────────────────────────────────────────
     layout/theme.liquid + sections/sunrunner-product.liquid inject:
       window.FOREIGN = {
         shopify: true,
         routes: { cartAdd: '/cart/add.js', cart: '/cart.js', cartUrl: '/cart' },
         variants: { XS: {id: 123, available: true}, ... },
         cartCount: 0
       }
     With no window.FOREIGN present the file behaves exactly as the static
     preview did, so the same script drives both.                         */
  var SHOP = window.FOREIGN || null; var RELEASE_LABEL = 'Releases August 7'; var RELEASE_LOCKED = Date.now() < Date.parse('2026-08-07T00:00:00-07:00');
  var IS_SHOPIFY = !!(SHOP && SHOP.shopify);
  var ROUTES = (SHOP && SHOP.routes) || { cartAdd: '/cart/add.js', cart: '/cart.js', cartUrl: '/cart' };
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var IO = 'IntersectionObserver' in window;

  // ── Announcement ticker ────────────────────────────────────────────
  var messages = ['First Batch', 'Black', 'Limited Run', 'UPF 50+'];
  var track = document.getElementById('marquee');
  if (track && track.dataset.messages) {
    // Shopify: theme setting "Marquee messages", one per line.
    var fromSettings = track.dataset.messages.split(/\r?\n/).map(function (s) { return s.trim(); }).filter(Boolean);
    if (fromSettings.length) messages = fromSettings;
  }
  if (track) {
    var unit = '';
    messages.forEach(function (m) { unit += '<span>' + m + '</span><span class="sep">·</span>'; });
    track.innerHTML = unit + unit;
  }

  // ── Mobile drawer ──────────────────────────────────────────────────
  var drawer = document.getElementById('drawer');
  var openM = document.getElementById('menuOpen');
  var closeM = document.getElementById('menuClose');
  var scrollLockY = 0;
  function openMenu() {
    if (!drawer) return;
    scrollLockY = window.scrollY;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var first = drawer.querySelector('nav a');
    if (first) first.focus({ preventScroll: true });
  }
  function closeMenu() {
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    window.scrollTo(0, scrollLockY);
    if (openM) openM.focus({ preventScroll: true });
  }
  if (openM && drawer) openM.addEventListener('click', openMenu);
  if (closeM && drawer) closeM.addEventListener('click', closeMenu);
  document.querySelectorAll('[data-close]').forEach(function (a) {
    a.addEventListener('click', closeMenu);
  });
  if (drawer) {
    drawer.setAttribute('aria-hidden', 'true');
    document.addEventListener('keydown', function (e) {
      if (!drawer.classList.contains('open')) return;
      if (e.key === 'Escape') { closeMenu(); return; }
      if (e.key !== 'Tab') return;
      var f = drawer.querySelectorAll('a[href],button:not([disabled])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  // ── Toast ──────────────────────────────────────────────────────────
  var toast = document.getElementById('toast');
  var toastT;
  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toast.classList.remove('show'); }, 2200);
  }

  // ── Bottom-sheet helpers ───────────────────────────────────────────
  function openSheet(el) {
    if (!el) return;
    el.setAttribute('data-open', '');
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeSheet(el) {
    if (!el) return;
    el.removeAttribute('data-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-sheet-close]').forEach(function (x) {
    x.addEventListener('click', function () { closeSheet(x.closest('.sheet')); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.sheet[data-open]').forEach(closeSheet);
  });

  // ── Size + cart state (single source of truth) ─────────────────────
  var cartCount = document.getElementById('cartCount');
  var count = (SHOP && typeof SHOP.cartCount === 'number') ? SHOP.cartCount : 0;
  var addBtn = document.getElementById('addBtn');
  var stickyBtn = document.getElementById('stickySelect');
  var stickyN = document.querySelector('.sticky-buy__t .n');
  var stickyP = document.querySelector('.sticky-buy__t .p');
  var packActive = document.getElementById('packActive');
  var sizeHeadLabel = document.getElementById('sizeHeadLabel');

  // Analytics ---------------------------------------------------------
  function trackEv(ev, data) {
    (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'foreign_' + ev, product: 'the-sunrunner' }, data || {}));
    if (window.console && console.debug) console.debug('[analytics]', ev, data || {});
  }

  // Editable bundle settings (wire to store/CMS) ----------------------
  var SIZES = ['XS', 'S', 'M', 'L', 'XL'];
  var STOCK = IS_SHOPIFY ? { XS: 0, S: 0, M: 0, L: 0, XL: 0 } : { XS: 12, S: 24, M: 30, L: 24, XL: 16 };
  if (IS_SHOPIFY && SHOP.variants) {
    // Availability is Shopify's — never hardcode inventory.
    SIZES.forEach(function (s) {
      var v = SHOP.variants[s];
      STOCK[s] = (v && v.available) ? 99 : 0;
    });
  }
  function variantId(size) { return (IS_SHOPIFY && SHOP.variants[size]) ? SHOP.variants[size].id : null; }
  var PACKS = {
    '1': { qty: 1, total: 49, each: 49, save: 0 },
    '2': { qty: 2, total: 88, each: 44, save: 10 },
    '3': { qty: 3, total: 117, each: 39, save: 30 }
  };
  function inStock(sz) { return !RELEASE_LOCKED && SIZES.indexOf(sz) !== -1 && (STOCK[sz] || 0) > 0; }

  // State (preserved across pack switches) ----------------------------
  var pack = '1';
  var sel = { '1': null, '2': [null, null], '3': [null, null, null] };
  var started = {}, completedFired = {};

  // Build size grids from inventory -----------------------------------
  function buildGrid(el) {
    el.innerHTML = SIZES.map(function (s) {
      var out = !inStock(s);
      return '<button class="size' + (out ? ' size--out' : '') + '" type="button" data-size="' + s + '" aria-pressed="false"' + (out ? ' disabled aria-disabled="true" title="Sold out"' : '') + '>' + s + '</button>';
    }).join('');
  }
  document.querySelectorAll('.pdp__sizes').forEach(buildGrid);

  // Completion helpers ------------------------------------------------
  function selectedCount() {
    if (pack === '1') return sel['1'] ? 1 : 0;
    return sel[pack].filter(Boolean).length;
  }
  function isComplete() { return selectedCount() === PACKS[pack].qty; }

  // Reflect state onto the grids --------------------------------------
  function refreshGrids() {
    var single = document.querySelector('[data-grid="single"]');
    if (single) single.querySelectorAll('.size').forEach(function (b) {
      b.setAttribute('aria-pressed', b.dataset.size === sel['1'] ? 'true' : 'false');
    });
    document.querySelectorAll('[data-grid="multi"]').forEach(function (grid) {
      var p = grid.getAttribute('data-pack'), i = +grid.getAttribute('data-idx');
      grid.querySelectorAll('.size').forEach(function (b) {
        b.setAttribute('aria-pressed', b.dataset.size === sel[p][i] ? 'true' : 'false');
      });
    });
  }

  // Sync CTA / sticky / progress --------------------------------------
  function syncCTA() {
    var P = PACKS[pack], done = isComplete();
    if (addBtn) { if (RELEASE_LOCKED) { addBtn.textContent = RELEASE_LABEL; addBtn.classList.remove('is-active'); addBtn.disabled = true; addBtn.setAttribute('aria-disabled', 'true'); if (stickyBtn) { stickyBtn.textContent = RELEASE_LABEL; stickyBtn.disabled = true; stickyBtn.setAttribute('aria-disabled', 'true'); } return; }
      if (pack === '1') addBtn.textContent = done ? 'Add 1 to Bag — $49' : 'Select a size — $49';
      else addBtn.textContent = done ? ('Add ' + P.qty + ' to Bag — $' + P.total) : ('Choose ' + P.qty + ' Sizes');
      addBtn.classList.toggle('is-active', done);
    }
    if (packActive) packActive.textContent = pack + '-Pack · $' + P.each + ' each';
    syncFormFields();
    if (stickyN) stickyN.textContent = 'The Sunrunner';
    if (stickyP) stickyP.textContent = pack + '-Pack · $' + P.total;
    if (stickyBtn) stickyBtn.textContent = done ? ('Add ' + P.qty) : 'Select Size';
    ['2', '3'].forEach(function (p) {
      var el = document.querySelector('[data-prog="' + p + '"]');
      if (!el) return;
      var n = sel[p].filter(Boolean).length;
      el.textContent = n + ' of ' + p + ' selected';
      el.classList.toggle('done', n === +p);
    });
    if (done && !completedFired[pack]) { completedFired[pack] = true; trackEv('bundle_completed', { pack: pack, total: P.total }); }
    if (!done) completedFired[pack] = false;
  }
  function flash(el) {
    if (!el || RM) return;
    el.classList.add('flash');
    setTimeout(function () { el.classList.remove('flash'); }, 260);
  }
  function markStarted() { if (!started[pack]) { started[pack] = true; trackEv('size_selection_started', { pack: pack }); } }

  // Pack switching ----------------------------------------------------
  function showPanel() {
    document.querySelectorAll('.psz').forEach(function (p) { p.classList.toggle('active', p.getAttribute('data-for') === pack); });
    if (sizeHeadLabel) sizeHeadLabel.textContent = pack === '1' ? 'Size' : 'Sizes';
  }
  function gentleScroll() {
    if (RM) return;
    var wrap = document.getElementById('sizeWrap');
    if (!wrap) return;
    var r = wrap.getBoundingClientRect();
    if (r.bottom > window.innerHeight || r.top < 60) {
      window.scrollTo({ top: r.top + window.pageYOffset - 80, behavior: 'smooth' });
    }
  }
  function setPack(p, viaUser) {
    var changed = pack !== p;
    pack = p;
    document.querySelectorAll('.pack2__card').forEach(function (c) {
      c.setAttribute('aria-pressed', c.getAttribute('data-pack') === p ? 'true' : 'false');
    });
    showPanel(); refreshGrids(); syncCTA();
    if (viaUser) { trackEv(changed ? 'pack_changed' : 'pack_selected', { pack: p }); gentleScroll(); }
  }
  document.querySelectorAll('.pack2__card').forEach(function (c) {
    c.addEventListener('click', function () { setPack(c.getAttribute('data-pack'), true); });
  });

  // Size grid selection (single / multi / same-size) ------------------
  document.querySelectorAll('.pdp__sizes').forEach(function (grid) {
    var g = grid.getAttribute('data-grid');
    grid.addEventListener('click', function (e) {
      var b = e.target.closest('.size'); if (!b || b.disabled) return;
      var sz = b.dataset.size;
      markStarted();
      if (g === 'single') { sel['1'] = sz; flash(addBtn); }
      else if (g === 'multi') { sel[grid.getAttribute('data-pack')][+grid.getAttribute('data-idx')] = sz; }
      else if (g === 'all2') { applySame('2', sz); }
      else if (g === 'all3') { applySame('3', sz); }
      refreshGrids(); syncCTA();
    });
  });

  // Same-size shortcuts -----------------------------------------------
  document.querySelectorAll('[data-sameall]').forEach(function (btn) {
    var p = btn.getAttribute('data-sameall');
    var gridWrap = document.querySelector('[data-sameallgrid="' + p + '"]');
    btn.addEventListener('click', function () {
      var on = btn.getAttribute('aria-pressed') === 'true';
      btn.setAttribute('aria-pressed', on ? 'false' : 'true');
      if (gridWrap) gridWrap.hidden = on;
    });
  });
  function applySame(p, sz) {
    for (var i = 0; i < +p; i++) sel[p][i] = sz;
    var btn = document.querySelector('[data-sameall="' + p + '"]');
    var gridWrap = document.querySelector('[data-sameallgrid="' + p + '"]');
    if (btn) btn.setAttribute('aria-pressed', 'false');
    if (gridWrap) gridWrap.hidden = true;
  }

  // ── Cart confirmation drawer ───────────────────────────────────────
  var cartDrawer = document.getElementById('cartDrawer');
  function sizesSummary() {
    if (pack === '1') return 'Black · Size ' + sel['1'];
    return 'Black · ' + sel[pack].join(', ');
  }
  function bundleVariants() { return pack === '1' ? [sel['1']] : sel[pack].slice(); }
  function openCart() {
    var cartDrawer = document.getElementById('cartDrawer');
    if (!cartDrawer) return;
    var P = PACKS[pack];
    var setTxt = function (id, t) { var el = document.getElementById(id); if (el) el.textContent = t; };
    setTxt('cartName', pack === '1' ? 'The Sunrunner Hoodie' : 'The Sunrunner — ' + pack + '-Pack');
    setTxt('cartVar', sizesSummary());
    setTxt('cartPrice', '$' + P.total);
    var save = document.getElementById('cartSave');
    if (save) { if (P.save > 0) { save.textContent = 'Bundle saving · $' + P.save; save.hidden = false; } else save.hidden = true; }
    var badge = document.getElementById('cartThumbN');
    if (badge) { if (P.qty > 1) { badge.textContent = '×' + P.qty; badge.hidden = false; } else badge.hidden = true; }
    cartDrawer.setAttribute('data-open', '');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    var cartDrawer = document.getElementById('cartDrawer');
    if (!cartDrawer) return;
    cartDrawer.removeAttribute('data-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-cart-close]').forEach(function (x) { x.addEventListener('click', closeCart); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
  var cartCheckout = document.getElementById('cartCheckout');
  if (cartCheckout) cartCheckout.addEventListener('click', function () {
    trackEv('checkout_started', { items: count });
    if (IS_SHOPIFY) { window.location.href = ROUTES.cartUrl; return; }
    showToast('Checkout — ' + count + ' item' + (count > 1 ? 's' : ''));
    closeCart();
  });
  var cartEdit = document.getElementById('cartEdit');
  if (cartEdit) cartEdit.addEventListener('click', function () { closeCart(); gentleScroll(); });

  function syncFormFields() {
    var idField = document.getElementById('variantIdField');
    var qtyField = document.getElementById('quantityField');
    if (!idField || !qtyField) return;
    var first = bundleVariants()[0];
    var id = variantId(first);
    if (id) idField.value = id;
    qtyField.value = PACKS[pack].qty;
  }

  function setBtnState(state, label) {
    if (!addBtn) return;
    addBtn.classList.toggle('is-loading', state === 'loading');
    addBtn.disabled = state === 'loading';
    addBtn.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
    if (label) addBtn.textContent = label;
  }

  /* Pack = quantity of the SELECTED SIZE(S). Identical sizes are merged into
     one line item with a quantity, so 3-Pack of M posts {id: M, quantity: 3}.
     The $88 / $117 pack totals are enforced by a Shopify automatic discount
     or discount function — never faked here. See PACK_DISCOUNT_HOOK below. */
  function cartLineItems() {
    var byId = {};
    bundleVariants().forEach(function (size) {
      var id = variantId(size);
      if (!id) return;
      byId[id] = (byId[id] || 0) + 1;
    });
    return Object.keys(byId).map(function (id) {
      return {
        id: Number(id),
        quantity: byId[id],
        /* PACK_DISCOUNT_HOOK — line properties let a Shopify discount function
           or automatic discount recognise the pack tier and apply $10 / $30 off.
           Configure the matching discount in Shopify admin; do not compute it here. */
        properties: { _pack: pack + '-Pack' }
      };
    });
  }

  function refreshCartCount() {
    return fetch(ROUTES.cart, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        count = c.item_count;
        if (cartCount) cartCount.textContent = String(count);
        document.dispatchEvent(new CustomEvent('foreign:cart:updated', { detail: c }));
        return c;
      });
  }

  function addBundle() { if (RELEASE_LOCKED) { setBtnState('error', RELEASE_LABEL); showToast(RELEASE_LABEL); return false; }
    if (!isComplete()) return false;
    var P = PACKS[pack];

    if (!IS_SHOPIFY) {
      count += P.qty;
      if (cartCount) cartCount.textContent = String(count);
      trackEv('bundle_added_to_cart', { pack: pack, qty: P.qty, total: P.total, save: P.save, variants: bundleVariants() });
      started[pack] = false;
      openCart();
      return true;
    }

    var items = cartLineItems();
    if (!items.length) { setBtnState('error', 'Unavailable — try another size'); return false; }
    setBtnState('loading', 'Adding…');
    fetch(ROUTES.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body && res.body.description || 'Cart error');
        return refreshCartCount();
      })
      .then(function () {
        setBtnState('done');
        trackEv('bundle_added_to_cart', { pack: pack, qty: P.qty, total: P.total, save: P.save, variants: bundleVariants() });
        started[pack] = false;
        syncCTA();
        openCart();
      })
      .catch(function (err) {
        setBtnState('error', 'Couldn’t add — try again');
        showToast(err && err.message ? err.message : 'Cart error');
        setTimeout(syncCTA, 2600);
      });
    return true;
  }
  function attemptAdd() { if (RELEASE_LOCKED) { showToast(RELEASE_LABEL); return; }
    if (isComplete()) { addBundle(); return; }
    gentleScroll();
    var grid = document.querySelector('.psz.active .pdp__sizes');
    if (grid && !RM) { grid.classList.add('shake'); setTimeout(function () { grid.classList.remove('shake'); }, 420); }
  }
  var productForm = document.getElementById('sunrunnerForm');
  if (productForm) productForm.addEventListener('submit', function (e) {
    // JS present: post to /cart/add.js so the drawer can open without a reload.
    // JS disabled: this handler never runs and Shopify posts the form natively.
    e.preventDefault();
    attemptAdd();
  });
  if (addBtn && !productForm) addBtn.addEventListener('click', attemptAdd);
  if (stickyBtn) stickyBtn.addEventListener('click', function () { if (isComplete()) addBundle(); else gentleScroll(); });
  ['heroChoose', 'finalChoose'].forEach(function (id) {
    var el = document.getElementById(id);
    if (el) el.addEventListener('click', function () {
      var buy = document.getElementById('buy');
      if (buy && !RM) window.scrollTo({ top: buy.getBoundingClientRect().top + window.pageYOffset - 60, behavior: 'smooth' });
      else if (buy) buy.scrollIntoView();
    });
  });
  window.addEventListener('beforeunload', function () {
    if (started[pack] && !isComplete()) trackEv('bundle_abandoned', { pack: pack });
  });

  // ── Size guide sheet ───────────────────────────────────────────────
  var sgLink = document.getElementById('sizeGuideLink');
  var sgSheet = document.getElementById('sizeGuide');
  if (sgLink && sgSheet) sgLink.addEventListener('click', function () { openSheet(sgSheet); });

  trackEv('pack_viewed', { pack: pack });
  setPack('1', false);

  // ── Cart button ────────────────────────────────────────────────────
  var cartBtn = document.getElementById('cartBtn');
  if (cartBtn) cartBtn.addEventListener('click', function () {
    showToast(count ? count + ' item' + (count > 1 ? 's' : '') + ' in bag' : 'Your bag is empty');
  });

  // ── Email capture ──────────────────────────────────────────────────
  var form = document.getElementById('emailForm');
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault(); form.reset(); showToast("You're on the list ✦");
  });

  // ── Smooth anchor scroll ───────────────────────────────────────────
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (id === '#' || id.length < 2) return;
      var el = document.querySelector(id);
      if (!el) return;
      e.preventDefault();
      var y = el.getBoundingClientRect().top + window.pageYOffset - 64;
      window.scrollTo({ top: y, behavior: RM ? 'auto' : 'smooth' });
    });
  });

  // ── Product media gallery (data-driven, collapses empty slots) ─────
  (function () {
    var gal = document.getElementById('gallery');
    if (!gal) return;
    var stage = document.getElementById('galStage');
    var rail = document.getElementById('galRail');
    var page = document.getElementById('galPage');
    var PDP = gal.getAttribute('data-pdp-href');

    // Replaceable campaign-media manifest. Front, side and back ship with the
    // theme; slots 04–08 remain reserved for campaign imagery and motion.
    // Editable alt & caption, configurable focal point (pos), reorder by moving
    // array entries.
    var MEDIA = [
      { n: 1, id: 'front',     kind: 'image', label: 'Product Front',  src: (SHOP && SHOP.assetBase ? SHOP.assetBase : 'uploads/') + 'Black-ThreeQuarter-Hem-Logo.png', alt: 'The Sunrunner Hoodie in Black, front view', pos: 'center 28%', caption: '' },
      { n: 2, id: 'side',      kind: 'image', label: 'Product Side',   src: (SHOP && SHOP.assetBase ? SHOP.assetBase : 'uploads/') + 'Sunrunner-Side.png', alt: 'The Sunrunner Hoodie in Black, three-quarter side view', pos: 'center 28%', caption: '' },
      { n: 3, id: 'back',      kind: 'image', label: 'Product Back',   src: (SHOP && SHOP.assetBase ? SHOP.assetBase : 'uploads/') + 'BB.png', alt: 'The Sunrunner Hoodie in Black, back view', pos: 'center 28%', caption: '' },
      { n: 4, id: 'concrete',  kind: 'image', label: 'Concrete',       src: '', alt: '', pos: 'center', caption: '' },
      { n: 5, id: 'coast',     kind: 'image', label: 'Coast',          src: '', alt: '', pos: 'center', caption: '' },
      { n: 6, id: 'elevation', kind: 'image', label: 'Elevation',      src: '', alt: '', pos: 'center', caption: '' },
      { n: 7, id: 'detail',    kind: 'image', label: 'Product Detail', src: '', alt: '', pos: 'center', caption: '' },
      { n: 8, id: 'motion',    kind: 'video', label: 'Motion',         src: '', poster: '', alt: '', caption: '' }
    ];
    // Shopify: media positions are filled from window.FOREIGN.media. The product
    // section sends the packaged front/side/back sequence first, followed by any
    // campaign media supplied after those positions in Shopify admin. Unfilled
    // positions remain visible as labels in the editor and collapse on the live store.
    if (SHOP && SHOP.media && SHOP.media.length) {
      SHOP.media.forEach(function (m, i) {
        if (!MEDIA[i]) MEDIA[i] = { n: i + 1, id: 'slot' + (i + 1), kind: 'image', label: '', pos: 'center', caption: '' };
        MEDIA[i].kind = m.kind || 'image';
        MEDIA[i].src = m.src || '';
        MEDIA[i].poster = m.poster || '';
        MEDIA[i].alt = m.alt || '';
        if (m.label) MEDIA[i].label = m.label;
      });
    }

    // Editor preview shows unfilled slots as labelled frames.
    // Set false for the customer-facing live page to collapse empty slots.
    var SHOW_EMPTY_SLOTS = (SHOP && typeof SHOP.showEmptySlots === 'boolean') ? SHOP.showEmptySlots : true;

    function filled(m) { return !!m.src; }
    function hidden(m) { return m.hide === true; }
    var slides = MEDIA.filter(function (m) { return !hidden(m) && (filled(m) || SHOW_EMPTY_SLOTS); });
    if (!slides.length) return;
    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    stage.innerHTML = '';
    if (rail) rail.innerHTML = '';
    slides.forEach(function (m, i) {
      var frame = document.createElement('div');
      frame.className = 'gal__frame' + (i === 0 ? ' is-on' : '');
      if (filled(m)) {
        frame.classList.add('gal__frame--fill');
        if (m.kind === 'video') {
          frame.classList.add('gal__frame--dark');
          var v = document.createElement('video');
          v.muted = true; v.loop = true; v.playsInline = true;
          v.setAttribute('playsinline', ''); v.setAttribute('muted', '');
          v.preload = 'none';
          if (m.poster) v.poster = m.poster;
          var src = document.createElement('source'); src.src = m.src; v.appendChild(src);
          frame.appendChild(v);
        } else {
          var img = document.createElement('img');
          img.src = m.src; img.alt = m.alt || m.label;
          img.style.objectPosition = m.pos || 'center';
          img.loading = i < 2 ? 'eager' : 'lazy';
          img.decoding = 'async';
          if (i === 0) img.setAttribute('fetchpriority', 'high');
          frame.appendChild(img);
        }
        if (m.caption) {
          var cap = document.createElement('span'); cap.className = 'gal__cap'; cap.textContent = m.caption;
          frame.appendChild(cap);
        }
      } else {
        var ph = document.createElement('div'); ph.className = 'gal__ph';
        var pm = document.createElement('span'); pm.className = 'm'; pm.textContent = 'Media ' + pad(m.n);
        var pt = document.createElement('span'); pt.className = 't'; pt.textContent = m.label;
        var pk = document.createElement('span'); pk.className = 'k'; pk.textContent = m.kind === 'video' ? '4:5 campaign video' : '4:5 campaign image';
        ph.appendChild(pm); ph.appendChild(pt); ph.appendChild(pk);
        frame.appendChild(ph);
      }
      stage.appendChild(frame);
      if (rail) {
        var th = document.createElement('button');
        th.type = 'button';
        th.className = 'gal__thumb' + (i === 0 ? ' is-on' : '');
        th.setAttribute('aria-label', m.label);
        if (filled(m) && m.kind === 'image') {
          var ti = document.createElement('img'); ti.src = m.src; ti.alt = ''; ti.style.objectPosition = m.pos || 'center'; ti.loading = 'lazy';
          th.appendChild(ti);
        } else if (filled(m) && m.kind === 'video' && m.poster) {
          var tp = document.createElement('img'); tp.src = m.poster; tp.alt = ''; tp.loading = 'lazy';
          th.appendChild(tp);
        } else {
          var tph = document.createElement('div'); tph.className = 'galt__ph';
          var tn = document.createElement('span'); tn.className = 'num'; tn.textContent = pad(m.n);
          var tl = document.createElement('span'); tl.textContent = m.label;
          tph.appendChild(tn); tph.appendChild(tl);
          th.appendChild(tph);
        }
        rail.appendChild(th);
      }
    });

    var frames = Array.prototype.slice.call(stage.querySelectorAll('.gal__frame'));
    var thumbs = rail ? Array.prototype.slice.call(rail.querySelectorAll('.gal__thumb')) : [];
    var idx = 0;
    function render() {
      frames.forEach(function (f, i) { f.classList.toggle('is-on', i === idx); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-on', i === idx); });
      if (page) page.textContent = (idx + 1) + ' / ' + frames.length;
      if (rail && thumbs[idx]) {
        var t = thumbs[idx];
        var target = t.offsetLeft - (rail.clientWidth - t.offsetWidth) / 2;
        rail.scrollTo({ left: Math.max(0, target), behavior: RM ? 'auto' : 'smooth' });
      }
      frames.forEach(function (f, i) {
        var vv = f.querySelector('video'); if (!vv) return;
        if (i === idx && !RM) { if (vv.play) vv.play().catch(function () {}); } else if (vv.pause) vv.pause();
      });
    }
    function go(i) { idx = (i + frames.length) % frames.length; render(); }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function (e) { e.stopPropagation(); if (PDP) { window.location.href = PDP; return; } go(i); }); });

    var sx = null, sy = null;
    stage.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; });
    stage.addEventListener('pointerup', function (e) {
      if (sx === null) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(idx + (dx < 0 ? 1 : -1));
      else if (Math.abs(dx) < 10 && Math.abs(dy) < 10) tap();
      sx = null;
    });
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') go(idx + 1);
      else if (e.key === 'ArrowLeft') go(idx - 1);
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); tap(); }
    });

    // tap: expand a filled image in the lightbox; toggle controls on video
    var lb = document.getElementById('lightbox');
    var lbImg = document.getElementById('lightboxImg');
    function tap() {
      if (PDP) { window.location.href = PDP; return; }
      var f = frames[idx]; if (!f) return;
      var v = f.querySelector('video'); if (v) { v.controls = !v.controls; return; }
      var img = f.querySelector('img');
      if (img && lb && lbImg) {
        lbImg.src = img.src; lbImg.alt = img.alt;
        lb.setAttribute('data-open', ''); lb.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
    }
    function closeLb() {
      if (!lb) return;
      lb.removeAttribute('data-open'); lb.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    if (lb) {
      lb.querySelectorAll('[data-lb-close]').forEach(function (x) { x.addEventListener('click', closeLb); });
      lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLb(); });
    }

    // pause videos while offscreen; loop only when visible
    if (IO) {
      var vio = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          var v = en.target, f = v.closest('.gal__frame');
          if (en.isIntersecting && f && f.classList.contains('is-on') && !RM) { if (v.play) v.play().catch(function () {}); }
          else if (v.pause) v.pause();
        });
      }, { threshold: 0.4 });
      frames.forEach(function (f) { var v = f.querySelector('video'); if (v) vio.observe(v); });
    }

    render();
  })();

  // ── Sticky purchase bar (reveal once purchase module leaves view) ──
  (function () {
    var bar = document.getElementById('stickyBuy');
    var buy = document.getElementById('stickySentinel') || document.getElementById('buy');
    if (!bar || !buy || !IO) return;
    var io = new IntersectionObserver(function (ents) {
      var en = ents[0];
      var past = !en.isIntersecting && en.boundingClientRect.bottom < 0;
      bar.classList.toggle('show', past);
      bar.setAttribute('aria-hidden', past ? 'false' : 'true');
    }, { threshold: 0 });
    io.observe(buy);
  })();

  // ── Hero entrance ──────────────────────────────────────────────────
  (function () {
    var hero = document.querySelector('.hero');
    var header = document.querySelector('header.site');
    function enter() {
      if (header) header.classList.add('entered');
      if (hero) hero.classList.add('entered');
    }
    if (RM) { enter(); return; }
    requestAnimationFrame(function () { requestAnimationFrame(enter); });
  })();

  // ── Editorial reveals (once, at ~25%) ──────────────────────────────
  (function () {
    if (RM || !IO) return;
    var map = new Map();
    [
      ['.stakes', ['.pill', 'h2', '.stakes__lead', '.proof98', '#whyupf']],
      ['.specs2', ['.eyebrow', '.acc']],
      ['.story', ['.pill', '.story__lead']],
      ['.faq', ['.eyebrow', '.faq__list']]
    ].forEach(function (pair) {
      var sec = document.querySelector(pair[0]);
      if (!sec) return;
      var els = pair[1].map(function (s) { return sec.querySelector(s); }).filter(Boolean);
      els.forEach(function (el) { el.classList.add('mrev'); });
      map.set(sec, els);
    });
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        var els = map.get(en.target) || [];
        els.forEach(function (el, i) { setTimeout(function () { el.classList.add('in'); }, i * 80); });
        io.unobserve(en.target);
      });
    }, { threshold: 0.25 });
    map.forEach(function (_, sec) { io.observe(sec); });
  })();

  // ── Proof strip 3D reveal (once) ───────────────────────────────────
  (function () {
    var ps = document.querySelector('.pstrip');
    if (!ps) return;
    if (RM || !IO) { ps.classList.add('in'); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        ps.classList.add('in');
        io.unobserve(ps);
      });
    }, { threshold: 0.4 });
    io.observe(ps);
  })();

  // ── FOREIGN interstitial (two-line reveal after hard cut) ──────────
  (function () {
    var creed = document.querySelector('.creed');
    if (!creed) return;
    if (RM || !IO) { creed.classList.add('in'); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        creed.classList.add('in');
        io.unobserve(creed);
      });
    }, { threshold: 0.3 });
    io.observe(creed);
  })();

  // ── Anatomy: sequence + fabric drift ───────────────────────────────
  (function () {
    var why = document.querySelector('.why');
    if (!why) return;
    if (RM || !IO) { why.classList.add('in-view'); }
    else {
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          if (!en.isIntersecting) return;
          why.classList.add('in-view');
          io.unobserve(why);
        });
      }, { threshold: 0.25 });
      io.observe(why);
    }
    // fabric-texture drift (~92% of scroll speed)
    if (RM) return;
    var canvas = document.getElementById('grain-canvas');
    if (!canvas) return;
    var ticking = false;
    function update() {
      ticking = false;
      var r = why.getBoundingClientRect();
      var vh = window.innerHeight;
      var center = r.top + r.height / 2;
      var y = Math.max(-14, Math.min(14, (vh / 2 - center) * 0.08));
      canvas.style.transform = 'translateY(' + y.toFixed(1) + 'px)';
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  })();

  // ── Generic .rise reveal safety net (anatomy header masks) ─────────
  (function () {
    if (RM || !IO) {
      document.querySelectorAll('.rise').forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('in');
        io.unobserve(en.target);
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('.rise').forEach(function (el) {
      if (!el.classList.contains('in')) io.observe(el);
    });
  })();

  // ── FAQ: only one answer open at a time ────────────────────────────
  (function () {
    var items = document.querySelectorAll('.faq__list details');
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        items.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  })();

})();
